import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { QuoteItemCommentResponse } from "@/main/models/response";
import { useEffect, useRef } from "react";
import Comment from "./comment/comment";
import * as S from "./styles";

interface IGridCommentsProps {
	comments: QuoteItemCommentResponse[];
	isLoadingComments: boolean;
	replyComment: (idComment: string) => void;
}
function GridComments({ comments, replyComment, isLoadingComments }: IGridCommentsProps) {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollTop = containerRef.current.scrollHeight;
		}
	}, [isLoadingComments]);

	if (isLoadingComments) return <LoadingComponent />;
	if (comments.length === 0) return null;

	return (
		<S.Container ref={containerRef}>
			{comments.map((comment, index) => (
				<Comment key={index} comment={comment} comments={comments} replyComment={replyComment} />
			))}
		</S.Container>
	);
}

export default GridComments;
